export enum WaterTransferDocumentServiceStatus {
    NotComplete,
    Complete,
}
